<template>
    <div class="about__section">
        <h3>{{ l('ABOUT.QUEUE_HEADING') }}</h3>
        <dl>
            <dt>{{ l('ABOUT.QUEUE_RUNNING') }}</dt>
            <dd>{{ numberFilter(onlineQueueRunningLength) }}</dd>

            <dt>{{ l('ABOUT.QUEUE_PENDING') }}</dt>
            <dd>{{ numberFilter(onlineQueuePendingLength) }}</dd>

            <dt>{{ l('ABOUT.QUEUE_FAILED') }}</dt>
            <dd>{{ numberFilter(onlineQueueFailedLength) }}</dd>

            <dt></dt>
            <dd>
                <button v-if="onlineQueueAllLength"
                        class="btn btn-default btn-sm"
                        @click="exportQueue()">
                    {{ l('ABOUT.QUEUE_EXPORT') }}
                    <i v-if="generatingQueueExport"
                       class="fa-solid fa-spinner fa-spin"></i>
                </button>
            </dd>
        </dl>
    </div>
</template>

<script>
import moment from 'moment';
import { container } from '@/container';

export default {
    name: 'AboutQueueSection',

    data() {
        return {
            onlineQueueLength: null,
            onlineQueueAllLength: null,
            onlineQueueRunningLength: null,
            onlineQueuePendingLength: null,
            onlineQueueFailedLength: null,

            generatingQueueExport: false,
        };
    },

    created() {
        container.onlineQueue.countQueuedTasks()
            .then((count) => {
                this.onlineQueueLength = count;
            });

        container.onlineQueue.countAllTasks()
            .then((count) => {
                this.onlineQueueAllLength = count;
            });

        container.onlineQueue.countRunningTasks()
            .then((count) => {
                this.onlineQueueRunningLength = count;
            });

        container.onlineQueue.countPendingTasks()
            .then((count) => {
                this.onlineQueuePendingLength = count;
            });

        container.onlineQueue.countFailedTasks()
            .then((count) => {
                this.onlineQueueFailedLength = count;
            });
    },

    methods: {
        async exportQueue() {
            const confirmed = await container.dialogService.confirm(
                'ABOUT.QUEUE_EXPORT_CONFIRM', {
                    cancelLabel: 'CANCEL',
                    okLabel: 'I_UNDERSTAND_CONTINUE',
                    cancelColor: 'default',
                },
            );
            if (confirmed) {
                this.generatingQueueExport = true;

                const download = (
                    filename,
                    contents,
                ) => {
                    const file = new File([contents], filename, { type: 'application/json' });
                    const url = URL.createObjectURL(file);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(url);
                    this.generatingQueueExport = false;
                };

                const exportData = await container.onlineQueue.getQueueAsJson();

                download('queue_' + moment().format('YMDHHmmss') + '.json', exportData);
            }
        },
    },
};
</script>
